// extracted by mini-css-extract-plugin
export default {"wrapper":"theme-and-color_wrapper__9TWWX","buttons":"theme-and-color_buttons__4OHA1"};